const MAX_TEXT_INPUT_LENGTH = 50;
const MAX_PHONE_LENGTH = 12;
const MAX_TEXTAREA_LENGTH = 150;

/**
 * Sanitizes text input by:
 * 1. Filtering special symbols (keeps letters, digits, spaces, and punctuation)
 * 2. Enforcing max length
 */
const sanitizeTextInput = (
  value: string,
  maxLength: number,
  textArea: boolean = false
): string => {
  // For text inputs: full punctuation (. , ! ? : ; - ( ) [ ] { } ' " / \ & % $ # @ * + = _ | ~ ` ^)
  // For text areas: only basic punctuation (. , ! ? : ; - ( ))
  const regex = textArea
    ? /[^\w\s.,!?:;\-()]/g
    : /[^\w\s.,!?:;\-()[\]{}'"/\\&%$#@*+=|~`^]/g;

  let sanitized = value.replace(regex, "");

  if (sanitized.length > maxLength) {
    sanitized = sanitized.substring(0, maxLength);
  }

  return sanitized;
};

/**
 * Sanitizes phone input by:
 * 1. Keeping only digits
 * 2. Enforcing max length (12)
 */
const sanitizePhoneInput = (value: string): string => {
  let sanitized = value.replace(/\D/g, "");

  if (sanitized.length > MAX_PHONE_LENGTH) {
    sanitized = sanitized.substring(0, MAX_PHONE_LENGTH);
  }

  return sanitized;
};

export {
  MAX_TEXT_INPUT_LENGTH,
  MAX_PHONE_LENGTH,
  MAX_TEXTAREA_LENGTH,
  sanitizeTextInput,
  sanitizePhoneInput,
};
